import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const queryService = {
    getAllQueries,
    updateQueryStatus,
    getQuery,
    updateQuery,
    createQuery,
};

const MODULE = {
    QUERY: 'rnd-product-queries',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Query') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllQueries(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            type: filter.type,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.QUERY}`, requestOptions)
}


export function updateQueryStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.QUERY}/${data.id}`, requestOptions)
}

export function getQuery(id) {
    return apiHelper(API_URL).get(`/${MODULE.QUERY}/${id}`)
}

export function updateQuery(data) {
    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        type: data.type,
        date: data.date,
    }

    return apiHelper(API_URL).put(`/${MODULE.QUERY}/${data.id}`, requestOptions)
}

export function createQuery(data) {
    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        type: data.type,
        date: data.date,
    }

    return apiHelper(API_URL).post(`/${MODULE.QUERY}`, requestOptions)
}